import { useState } from "react";
import { PATHWAY } from "@/constants/testIds";
import { THEMES } from "@/lib/pathwayData";
import { SectionEyebrow } from "@/components/pathway/Journey";

export default function Themes() {
  const [selected, setSelected] = useState("cyber-referral");
  const active = THEMES.find((t) => t.slug === selected);

  return (
    <section id="themes" className="border-t hairline bg-[#0f0f0f]">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <div className="grid gap-10 md:grid-cols-[1fr_1fr] md:gap-16">
          <div>
            <SectionEyebrow>II. Playground themes</SectionEyebrow>
            <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-neutral-50 sm:text-4xl lg:text-5xl">
              Ten emerging-risk themes a sponsor may convene around.
            </h2>
          </div>
          <p className="self-end text-neutral-400">
            Each theme is a sector storybook, not a software demo. The lab
            convenes brokers, clients, universities, technology partners and
            insurers in a synthetic-first conversation.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-0 border-t border-l hairline sm:grid-cols-2 lg:grid-cols-5">
          {THEMES.map((t) => {
            const isSelected = t.slug === selected;
            return (
              <button
                type="button"
                key={t.slug}
                onClick={() => setSelected(t.slug)}
                data-testid={PATHWAY.themeCard(t.slug)}
                aria-pressed={isSelected}
                className={`group border-b border-r hairline p-6 text-left transition-colors ${
                  isSelected
                    ? "bg-[#1a1a1a]"
                    : "bg-transparent hover:bg-[#141414]"
                }`}
              >
                <div
                  className={`font-mono text-[10px] uppercase tracking-[0.24em] ${
                    isSelected ? "text-amber-600" : "text-neutral-500"
                  }`}
                >
                  {String(THEMES.indexOf(t) + 1).padStart(2, "0")}
                </div>
                <div
                  className={`mt-3 font-serif text-lg leading-snug ${
                    isSelected ? "text-neutral-50" : "text-neutral-200"
                  }`}
                >
                  {t.title}
                </div>
                {t.featured && (
                  <div className="mt-3 inline-block border border-amber-700/60 px-2 py-0.5 font-mono text-[9px] uppercase tracking-[0.2em] text-amber-600">
                    First sample
                  </div>
                )}
              </button>
            );
          })}
        </div>

        <div
          data-testid={PATHWAY.themeSelected}
          className="mt-10 border-l-2 border-amber-700 pl-6"
        >
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-amber-600">
            Selected theme
          </div>
          <div className="mt-2 font-serif text-2xl text-neutral-100">
            {active?.title}
          </div>
        </div>
      </div>
    </section>
  );
}
